export default [
    {
        id: 'node-form',
        className: 'icon-form',
        sourcePosition: 'right',
        type: 'input',
        data: { label: 'Form' },
        position: { x: 0, y: 80 },
    },
    {
        id: 'node-extra',
        type: 'default',
        className: 'annotation',
        data: {
            label: (
                <>
                    <h5>Branching</h5>
                    <p>If <span>C</span> then jump to <strong>Q4</strong></p>
                </>
            ),
        },
        // draggable: false,
        selectable: false,
        position: { x: 225, y: -30 },
    },
    {
        id: 'node-1',
        className: 'icon-multiple',
        targetPosition: 'left',
        sourcePosition: 'right',
        data: { label: 'Q1' },
        position: { x: 200, y: 80 },
    },
    {
        id: 'node-2',
        className: 'icon-text',
        sourcePosition: 'right',
        targetPosition: 'left',
        data: { label: 'Q2' },
        position: { x: 450, y: 0 },
    },
    {
        id: 'node-3',
        className: 'icon-opinion',
        sourcePosition: 'right',
        targetPosition: 'left',
        data: { label: 'Q3' },
        position: { x: 380, y: 177 },
    },
    {
        id: 'node-4',
        className: 'icon-text',
        sourcePosition: 'right',
        targetPosition: 'left',
        data: { label: 'Q4' },
        position: { x: 625, y: 220 },

    },
    {
        id: 'node-5',
        className: 'icon-text',
        sourcePosition: 'right',
        targetPosition: 'left',
        data: { label: 'Q5' },
        position: { x: 840, y: 8 },

    },
    {
        id: 'node-6',
        className: 'icon-opinion',
        sourcePosition: 'right',
        targetPosition: 'left',
        data: { label: 'Q6' },
        position: { x: 840, y: 171 },
    },
    {
        id: 'node-7',
        type: 'output',
        targetPosition: 'left',
        data: { label: 'Thankyou page' },
        position: { x: 1020, y: 80 },
    }
];